module.exports = __webpack_public_path__ + "img/ic_12_next_merkur.ff6e2875.svg";